import { render, staticRenderFns } from "./CentroidIndicator.vue?vue&type=template&id=327e42eb&scoped=true"
import script from "./CentroidIndicator.vue?vue&type=script&lang=ts"
export * from "./CentroidIndicator.vue?vue&type=script&lang=ts"
import style0 from "./CentroidIndicator.vue?vue&type=style&index=0&id=327e42eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e42eb",
  null
  
)

export default component.exports